<script>
    import { onMount } from "svelte";

  
    let file; // Almacenar el archivo PDF seleccionado
    let pdfDoc; // Documento PDF cargado
    let canvasEl; // Canvas para renderizar el PDF
    let pageNum = 1; // Número de la página inicial
  
    // Cargar el archivo PDF al cambiar el input
  
    let aviso = '';
    
    export let pdf
  
      async function preview() {
      let response = await fetch('');
      const selectedFile = await response.blob(); 
  
      let load = await pdfvery(selectedFile);
    }
  
    async function pdfvery(selectedFile) {
  
      if (selectedFile) {
        file = selectedFile;
        
        loadPDF();
      } else {
        /* alert("Por favor, selecciona un archivo PDF."); */
        aviso = 'No cargo correctamente el menú.'
      }
    }
  
    onMount(async () => {
      pdfvery(pdf);
  
  });
  
  
    // Función para cargar y renderizar el PDF
    async function loadPDF() {
      try {
        pdfDoc = await pdfjsLib.getDocument(file).promise;
        renderPage(pageNum);
      } catch (error) {
       /*  console.log(error); */
        aviso = 'No cargo correctamente el menú.';
      }
    }
  
    // Renderizar una página del PDF en el canvas
    function renderPage(pageNum) {
      pdfDoc.getPage(pageNum).then(function (page) {
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = canvasEl;
        const ctx = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
  
        const renderContext = {
          canvasContext: ctx,
          viewport: viewport,
        };
        page.render(renderContext);
      });
    }
  
    // Avanzar a la siguiente página
    function nextPage() {
      if (pageNum < pdfDoc.numPages) {
        pageNum++;
        renderPage(pageNum);
      }
    }
  
    // Retroceder a la página anterior
    function prevPage() {
      if (pageNum > 1) {
        pageNum--;
        renderPage(pageNum);
      }
    }

  
  </script>
  
  <svelte:head>
    <script
      src="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.min.js"
    ></script>


  </svelte:head>
  
  <!-- Canvas para mostrar el PDF -->
  
  <div class="row">
    <div class="col-12 mb-3 text-center">
      <h2>Menu</h2>
    </div>
  </div> 
   
  
   <h3>{aviso}</h3>
  <!-- Controles para cambiar entre páginas -->
  {#if pdfDoc}
  <div class="controls">
    <button class='btn btn-primary-outline' on:click={prevPage}>
      <i class="bi bi-arrow-left"></i>
      Página anterior
    </button>
    <button class='btn btn-primary-outline' on:click={nextPage}>Página siguiente
      <i class="bi bi-arrow-right"></i>
    </button>
    
  </div> 
  <div class="row">
    <div class="col-12">
      <canvas bind:this={canvasEl}></canvas>
    </div>
   </div>
  
    <div class="controls">
      <button class='btn btn-primary-outline' on:click={prevPage}>
        <i class="bi bi-arrow-left"></i>
        Página anterior
      </button>
      <button class='btn btn-primary-outline' on:click={nextPage}>Página siguiente
        <i class="bi bi-arrow-right"></i>
      </button>
      
    </div>
  {/if}
  <div class="row p-3">
    <div class="col-12">
  
    </div>
  </div>
  
  <style>
    .controls {
      display: flex;
      justify-content: center;
      gap: 1rem;
    }
    canvas {
      display: block;
      margin: 0 auto;
      width: 100%;
  
    }
  </style>
  

